var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3235_2850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4548 0.958812L8.08484 1.42881C7.34484 1.48881 6.62484 1.75881 6.01484 2.18881L2.78484 4.46881C1.95484 5.04881 1.46484 5.99881 1.46484 7.01881V16.6588C1.46484 16.7988 1.48484 16.9388 1.52484 17.0788L2.44484 20.4688C2.51484 20.7388 2.65484 20.9788 2.85484 21.1788L4.29484 22.6288C4.59484 22.9288 5.00484 23.1088 5.43484 23.1088C5.78484 23.1088 6.12484 22.9988 6.39484 22.7888L6.54484 22.6788C6.54484 22.6788 6.66484 22.6488 6.69484 22.6988L6.93484 23.0388C7.17484 23.3688 7.52484 23.6088 7.92484 23.6888L8.33484 23.7788C8.45484 23.7988 8.57484 23.7588 8.64484 23.6688C8.80484 23.4688 9.12484 23.5288 9.19484 23.7788L9.30484 24.1788C9.30484 24.1788 9.36484 24.2588 9.41484 24.2588H17.2448C17.7748 24.2588 18.2648 23.9988 18.5648 23.5688L18.7548 23.2988C18.7948 23.2388 18.8848 23.2388 18.9348 23.2988L19.2748 23.7588C19.2748 23.7588 19.3548 23.8088 19.3948 23.7988L22.0248 22.9688C22.0248 22.9688 22.0748 22.9388 22.0848 22.9188L22.3248 22.4388C22.3948 22.2988 22.5848 22.2788 22.6848 22.3988C22.7848 22.5288 22.9848 22.4988 23.0548 22.3488L23.9648 20.2588C24.0648 20.0388 24.1048 19.7988 24.0948 19.5588L23.6248 7.33881C23.6248 7.16881 23.5948 6.99881 23.5548 6.83881L23.1348 5.19881C22.7348 3.65881 21.5048 2.48881 19.9448 2.15881L14.4948 1.01881C14.1548 0.948812 13.8048 0.928813 13.4548 0.958812Z",
    fill: "url(#paint0_linear_3235_2850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1552 11.1684L23.4452 10.4584C23.5252 10.4184 23.6052 10.3984 23.6952 10.3984H24.1852C24.3152 10.3984 24.4452 10.4484 24.5352 10.5384L24.7052 10.7084C24.8052 10.8084 24.8652 10.9484 24.8552 11.0884L24.7652 14.9484C24.7652 15.0584 24.7252 15.1684 24.6552 15.2584L24.0252 16.0384C23.8852 16.2084 23.6652 16.2684 23.4552 16.1984L22.4952 15.8584C22.3052 15.7884 22.1752 15.6184 22.1552 15.4184L21.8952 11.6684C21.8852 11.4684 21.9852 11.2884 22.1552 11.1884V11.1684Z",
    fill: "url(#paint1_linear_3235_2850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97445 11.1584L1.73445 10.4684C1.65445 10.4184 1.55445 10.3984 1.46445 10.3984H1.01445C0.864453 10.3984 0.724453 10.4584 0.624453 10.5584L0.484453 10.6984C0.374453 10.8084 0.314453 10.9584 0.314453 11.1184L0.404453 14.9384C0.404453 15.0584 0.454453 15.1784 0.524453 15.2784L1.11445 16.0184C1.26445 16.2084 1.51445 16.2784 1.74445 16.1984L2.63445 15.8784C2.84445 15.8084 2.99445 15.6084 3.00445 15.3884L3.26445 11.7084C3.28445 11.4884 3.16445 11.2884 2.97445 11.1784V11.1584Z",
    fill: "url(#paint2_linear_3235_2850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7347 7.50977H4.99469C3.64469 7.50977 2.55469 8.59977 2.55469 9.94977V15.0598C2.55469 17.5698 3.95469 19.8598 6.18469 21.0098L9.66469 22.8098C11.5947 23.8098 13.8847 23.8098 15.8147 22.8098L19.2947 21.0098C21.5247 19.8598 22.9247 17.5598 22.9247 15.0598V9.94977C22.9247 8.59977 21.8347 7.50977 20.4847 7.50977H12.7447H12.7347Z",
    fill: "url(#paint3_linear_3235_2850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.594 16.1289C12.034 16.2189 12.994 16.3789 13.814 16.1789C13.904 16.1589 13.964 16.2589 13.904 16.3289C13.574 16.6489 13.024 17.1689 12.754 17.2689C12.454 17.3689 11.814 16.6489 11.514 16.2789C11.464 16.2089 11.514 16.1189 11.604 16.1389L11.594 16.1289Z",
    fill: "url(#paint4_linear_3235_2850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9939 18.88C12.9939 18.88 11.9439 19.06 11.2539 18.25",
    stroke: "#E98E8A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9141 11.51L15.0141 12.19L19.5541 11.54L21.0141 12.19V12.01L19.5841 11.25L14.9141 11.51Z",
    fill: "#642C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1855 13.1191H20.5555C20.5555 13.1191 19.7255 15.1491 17.7355 15.1591C15.7455 15.1691 15.1855 13.1191 15.1855 13.1191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8741 14.2488C18.4041 14.2488 18.8441 13.8188 18.8441 13.2788C18.8441 13.1988 18.8341 13.1188 18.8141 13.0488H16.9441C16.9241 13.1288 16.9141 13.1988 16.9141 13.2788C16.9141 13.8088 17.3441 14.2488 17.8841 14.2488H17.8741Z",
    fill: "#2A2A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6341 12.9688L15.1641 13.0787C15.1641 13.0787 15.1641 13.0987 15.1841 13.1287H20.5541C20.6041 13.0287 20.6341 12.9688 20.6341 12.9688Z",
    fill: "#642C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5844 11.51L10.4744 12.19L5.93438 11.54L4.48438 12.19V12.01L5.91438 11.25L10.5844 11.51Z",
    fill: "#642C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3153 13.1191H4.94531C4.94531 13.1191 5.77531 15.1491 7.76531 15.1591C9.75531 15.1691 10.3153 13.1191 10.3153 13.1191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6243 14.2488C7.0943 14.2488 6.6543 13.8188 6.6543 13.2788C6.6543 13.1988 6.6643 13.1188 6.6843 13.0488H8.5543C8.5743 13.1288 8.5843 13.1988 8.5843 13.2788C8.5843 13.8088 8.1543 14.2488 7.6143 14.2488H7.6243Z",
    fill: "#2A2A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86523 12.9688L10.3352 13.0787C10.3352 13.0787 10.3352 13.0987 10.3152 13.1287H4.94523C4.89523 13.0287 4.86523 12.9688 4.86523 12.9688Z",
    fill: "#642C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8356 7.50992C18.8356 7.50992 16.6356 9.80992 15.1856 10.0899C13.7356 10.3699 12.3256 10.0899 12.3256 10.0899L14.5156 8.85992L9.84562 10.7499H6.93563L11.3956 8.40992L4.01562 11.7299L2.42562 13.9799L2.01562 7.51992L4.04562 4.19992L11.3956 2.41992H17.8656L22.0556 4.75992L23.2556 8.04992L22.9056 12.6099L22.4656 12.9799L21.2756 8.21992L18.0756 9.28992L17.0756 9.50992L18.8356 7.52992V7.50992Z",
    fill: "#642C20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_2850",
    x1: 12.7748,
    y1: 8.36881,
    x2: 12.7748,
    y2: 22.2288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#652E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6A362C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#73443C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7E5753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#815B58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3235_2850",
    x1: 23.4252,
    y1: 10.2284,
    x2: 23.2152,
    y2: 16.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3235_2850",
    x1: 1.72445,
    y1: 10.0684,
    x2: 1.93445,
    y2: 16.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3235_2850",
    x1: 12.7347,
    y1: 7.78977,
    x2: 12.7347,
    y2: 21.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3235_2850",
    x1: 12.704,
    y1: 16.4389,
    x2: 12.684,
    y2: 17.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C18988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3235_2850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.55,
    height: 23.3,
    fill: "white",
    transform: "translate(0.304688 0.949219)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeHead);
export default __webpack_public_path__ + "static/media/orange_head.5550e62fded29e5c2bff3e02b61b5aca.svg";
export { ForwardRef as ReactComponent };